var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4816 21.1338C22.7499 21.1334 23.0133 21.0621 23.2451 20.927C23.4769 20.792 23.6688 20.5979 23.8014 20.3647C23.934 20.1315 24.0025 19.8673 23.9999 19.599C23.9974 19.3308 23.9239 19.0679 23.7869 18.8373L13.3047 1.24093C13.1698 1.01504 12.9786 0.828015 12.7498 0.698144C12.521 0.568273 12.2624 0.5 11.9993 0.5C11.7362 0.5 11.4777 0.568273 11.2488 0.698144C11.02 0.828015 10.8289 1.01504 10.694 1.24093L0.213057 18.8373C0.076091 19.0679 0.00260751 19.3308 6.81248e-05 19.599C-0.00247126 19.8673 0.0660236 20.1315 0.198598 20.3647C0.331172 20.5979 0.523104 20.792 0.754905 20.927C0.986707 21.0621 1.25012 21.1334 1.5184 21.1338H22.4816Z",
    fill: "#FFCF54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2874 12.3787V7.93108C13.2874 7.58948 13.1517 7.26187 12.9102 7.02032C12.6686 6.77877 12.341 6.64307 11.9994 6.64307C11.6578 6.64307 11.3302 6.77877 11.0887 7.02032C10.8471 7.26187 10.7114 7.58948 10.7114 7.93108V12.3787C10.7114 12.7203 10.8471 13.0479 11.0887 13.2895C11.3302 13.531 11.6578 13.6667 11.9994 13.6667C12.341 13.6667 12.6686 13.531 12.9102 13.2895C13.1517 13.0479 13.2874 12.7203 13.2874 12.3787Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1995 18.1407C12.9016 18.0268 13.3785 17.3654 13.2647 16.6633C13.1509 15.9612 12.4895 15.4843 11.7874 15.5981C11.0853 15.7119 10.6084 16.3734 10.7222 17.0755C10.836 17.7776 11.4974 18.2545 12.1995 18.1407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningYellow);
export default __webpack_public_path__ + "static/media/icon-warning-yellow.5e25d427f186f61ee817cf2df063ba99.svg";
export { ForwardRef as ReactComponent };